export default __webpack_public_path__ + "static/media/PGSchoolEdit2.643034a6.png";